package org.hs_soft.runmynesto.domain.usecase.product.tab_price

import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_price.special_price.SpecialPriceModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_price.GetSpecialPriceRepository

class GetSpecialPriceUseCase(
    private val repository: GetSpecialPriceRepository
) {
    suspend operator fun invoke(id:String):SpecialPriceModel {
        return repository.getSpecialPrice(id=id)
    }


}